import { render, staticRenderFns } from "./resouce-entry.vue?vue&type=template&id=42d11845&scoped=true&"
import script from "./resouce-entry.vue?vue&type=script&lang=js&"
export * from "./resouce-entry.vue?vue&type=script&lang=js&"
import style0 from "./resouce-entry.vue?vue&type=style&index=0&id=42d11845&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d11845",
  null
  
)

export default component.exports